/* @sravni/react-design-system version 0.2.65 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import '../../Radio/index.js';
import '../../Checkbox/index.js';
import '../../Switch/index.js';
import '../../Space/index.js';
import modules_6b210db9 from '../styles/Menu.module.less.js';
import Radio from '../../Radio/src/Radio.js';
import Checkbox from '../../Checkbox/src/Checkbox.js';
import Switch from '../../Switch/src/Switch.js';
import Space from '../../Space/src/Space.js';

var ChildrenWrapper = function (args) {
    var children = args.children, props = __rest(args, ["children"]);
    return React.cloneElement(children, props);
};
/**
 * @description Menu Item component.
 *
 * @component
 * @example
 * ```jsx
 * <Menu.Item hint="hint">Content</Menu.Item>
 * ```
 */
var MenuItem = React.forwardRef(function (props, ref) {
    var value = props.value, icon = props.icon, control = props.control, hint = props.hint, description = props.description, active = props.active, disabled = props.disabled, className = props.className, children = props.children, restProps = __rest(props, ["value", "icon", "control", "hint", "description", "active", "disabled", "className", "children"]);
    var cx = useStyles(modules_6b210db9);
    var classNames = cx(className, 'itemBase', 'item', {
        active: active,
        disabled: disabled,
    });
    var iconClassNames = cx(className, 'icon', {
        disabled: disabled,
    });
    var controlClassNames = cx(className, 'control', {
        controlIndent: description || icon,
        disabled: disabled,
    });
    var descriptionClassNames = cx(className, 'description', {
        disabled: disabled,
    });
    var controlElement = React.useMemo(function () {
        // @ts-ignore
        if (control && (control.type === Radio || control.type === Checkbox || control.type === Switch)) {
            var inputProps = {
                value: value,
                disabled: disabled,
                checked: active,
                readOnly: true,
            };
            return React.createElement(ChildrenWrapper, __assign({}, inputProps), control);
        }
        return control;
    }, [active, disabled, control]);
    return (React.createElement(Space, __assign({ ref: ref, align: "center", size: 12, className: classNames }, restProps),
        icon && React.createElement("div", { className: iconClassNames }, icon),
        React.createElement(Space, { direction: "vertical", align: "start", size: 0 },
            hint && React.createElement("div", { className: descriptionClassNames }, hint),
            React.createElement("div", { className: cx('text') }, children),
            description && React.createElement("div", { className: descriptionClassNames }, description)),
        control && React.createElement("div", { className: controlClassNames }, controlElement)));
});
MenuItem.defaultProps = {};
MenuItem.displayName = 'MenuItem';

export default MenuItem;
//# sourceMappingURL=MenuItem.js.map
